export const isNumberBetween = (
  num: string | number,
  min: string | number,
  max: string | number
) => {
  num = Number(num);
  min = Number(min);
  if (max === "") {
    return num === min;
  } else {
    max = Number(max);
    return num >= min && num <= max;
  }
};
